import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Button, Flex, Input, Text } from '@workwhile/ui'
import { defs } from 'components/Shared/defs'
import { device } from 'components/Shared/device'
import { useIndeedFlexJobShiftsContextValue } from '../context/IndeedFlexJobShiftsProvider'

export const IndeedFlexJobShiftsFilterBar = () => {
  const {
    state: { filters },
    actions: { setFilters },
  } = useIndeedFlexJobShiftsContextValue()

  const [ifJobIdInput, setIfJobIdInput] = useState(
    filters.ifJobId !== null ? String(filters.ifJobId) : ''
  )

  useEffect(() => {
    setIfJobIdInput(filters.ifJobId !== null ? String(filters.ifJobId) : '')
  }, [filters.ifJobId])

  const handleSearch = () => {
    const parsedJobId = Number(ifJobIdInput)
    if (!Number.isInteger(parsedJobId) || parsedJobId <= 0) {
      setFilters({ ifJobId: null })
      return
    }

    setFilters({ ifJobId: parsedJobId })
  }

  return (
    <FilterBarWrapper showBorderTop showBorderBottom>
      <JobIdField>
        <Text fontSize={1} color="lightText" mb={1}>
          Indeed Flex Job ID
        </Text>
        <Flex alignItems="center" gap={2}>
          <Input
            type="number"
            min={1}
            step={1}
            value={ifJobIdInput}
            onChange={(event) => setIfJobIdInput(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                handleSearch()
              }
            }}
            placeholder="if_job_id"
            style={{ minWidth: 180 }}
          />
          <Button
            kind="small"
            onClick={handleSearch}
            disabled={ifJobIdInput === ''}
          >
            Search
          </Button>
        </Flex>
      </JobIdField>
    </FilterBarWrapper>
  )
}

const FilterBarWrapper = styled.div<{
  showBorderTop?: boolean
  showBorderBottom?: boolean
}>`
  border-bottom: ${(props) => (props.showBorderBottom ? '1px solid' : null)};
  border-top: ${(props) => (props.showBorderTop ? '1px solid' : null)};
  border-color: ${defs.veryLightBlack};
  padding: ${defs.paddingS};
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #fafafa;
  @media ${device.smallerThanMobileL} {
    font-size: ${defs.fontS};
    height: 100%;
    padding-left: ${defs.paddingM};
  }
`

const JobIdField = styled.div`
  margin-top: ${defs.marginXS};
  margin-bottom: ${defs.marginXS};
`
